import React, { useState } from 'react';
import { TouchableOpacity, View } from 'react-native';

import { CollapsebleTextButton } from './collapsable-text-button/collapsable-text-button';
import styles from './collapsable-text.style';
import { useColors } from '../../hooks/lesson-player.context';
import { Card } from '../activities/card/card';
import { TranslatableText } from '../translatable-text/translatable-text';

interface CollapsableTextProps {
  text?;
  translationText?;
  isMarkdown?: boolean;
  isHtml?: boolean;
  showHideBottom?: boolean;
}

export function CollapsableText({
  text,
  translationText,
  isMarkdown = false,
  isHtml = true,
  showHideBottom = true,
}: CollapsableTextProps) {
  const color = useColors();

  const [textActive, setTextActive] = useState(false);
  const toggleText = () => {
    setTextActive((active) => !active);
  };

  return (
    <View style={styles.content}>
      {!textActive && (
        <TouchableOpacity onPress={toggleText} style={styles.container1}>
          <CollapsebleTextButton
            typeText="onPrimary"
            nameIcon="angle-down"
            text="Show text"
            buttonColor={color.onPrimary}
          />
        </TouchableOpacity>
      )}
      {textActive && (
        <Card>
          <TouchableOpacity
            onPress={toggleText}
            style={[styles.container, styles.top]}
          >
            <CollapsebleTextButton />
          </TouchableOpacity>
          <View style={styles.textContainer}>
            <TranslatableText
              isMarkdown={isMarkdown}
              isHtml={isHtml}
              translation={translationText}
              style={styles.text}
            >
              {text}
            </TranslatableText>
          </View>
          {showHideBottom && (
            <TouchableOpacity
              onPress={toggleText}
              style={[styles.container, styles.bottom]}
            >
              <CollapsebleTextButton />
            </TouchableOpacity>
          )}
        </Card>
      )}
    </View>
  );
}
